import React from 'react'
import axios from 'axios'
import { Typography, TextField, Button, Checkbox, FormControlLabel, Grid } from '@material-ui/core'

const cardStyle = {
  backgroundColor: '#fff', borderRadius: 8,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)', padding: 16, marginBottom: 16
}

const KickoffCard = ({ projectId, kickoffMeeting, url, onUpdate }) => {
  const km = kickoffMeeting || {}
  const [scheduledDate, setScheduledDate] = React.useState(km.scheduledDate ? km.scheduledDate.slice(0, 10) : '')
  const [location, setLocation] = React.useState(km.location || '')
  const [attendees, setAttendees] = React.useState((km.attendees || []).join(', '))
  const [notes, setNotes] = React.useState(km.notes || '')
  const [confirmed, setConfirmed] = React.useState(km.confirmed || false)
  const [saving, setSaving] = React.useState(false)

  const handleSave = () => {
    setSaving(true)
    axios.put(`${url}/api/bid-estimation/projects/${projectId}/post-close`, {
      kickoffMeeting: {
        scheduledDate: scheduledDate || null,
        location,
        attendees: attendees.split(',').map(s => s.trim()).filter(Boolean),
        notes,
        confirmed
      }
    }).then(res => {
      setSaving(false)
      onUpdate(res.data)
    }).catch(err => { console.error(err); setSaving(false) })
  }

  const handleConfirmToggle = (e) => {
    const val = e.target.checked
    setConfirmed(val)
    // Auto-save on confirm toggle
    axios.put(`${url}/api/bid-estimation/projects/${projectId}/post-close`, {
      kickoffMeeting: {
        scheduledDate: scheduledDate || null, location,
        attendees: attendees.split(',').map(s => s.trim()).filter(Boolean),
        notes, confirmed: val
      }
    }).then(res => onUpdate(res.data)).catch(err => console.error(err))
  }

  return (
    <div style={cardStyle}>
      <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 12 }}>Kickoff Meeting</Typography>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField fullWidth size="small" variant="outlined" label="Date" type="date"
            value={scheduledDate} onChange={e => setScheduledDate(e.target.value)}
            InputLabelProps={{ shrink: true }} />
        </Grid>
        <Grid item xs={6}>
          <TextField fullWidth size="small" variant="outlined" label="Location"
            value={location} onChange={e => setLocation(e.target.value)} />
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth size="small" variant="outlined" label="Attendees (comma-separated)"
            value={attendees} onChange={e => setAttendees(e.target.value)} />
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth size="small" variant="outlined" label="Notes" multiline rows={2}
            value={notes} onChange={e => setNotes(e.target.value)} />
        </Grid>
      </Grid>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
        <FormControlLabel
          control={<Checkbox checked={confirmed} onChange={handleConfirmToggle} color="primary" size="small" />}
          label={<Typography variant="body2" style={{ fontSize: 12 }}>Confirmed</Typography>}
        />
        <Button size="small" variant="contained" color="primary" onClick={handleSave} disabled={saving}
          style={{ textTransform: 'none', fontSize: 12 }}>
          {saving ? 'Saving...' : 'Save'}
        </Button>
      </div>
    </div>
  )
}

export default KickoffCard
